import { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { route } from '../config';

const FormularForm = lazy(() => import('./FormularForm'));
const FormularListe = lazy(() => import('./FormularListe'));

export default function FormulareRoutes() {
  return (
    <Switch>
      <Route path={`${route}/f/:id`} component={FormularForm} />
      <Route path={`${route}/:filter`} component={FormularListe} />
      <Route path={route} component={() => <Redirect to={`${route}/draft`} />} />
    </Switch>
  );
}
